import { useQuery } from "@tanstack/react-query";
import Header from "@/components/Header";
import CartSheet from "@/components/CartSheet";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Manifesto from "@/components/sections/Manifesto";
import AboutUs from "@/components/sections/AboutUs";
import HowItWorks from "@/components/sections/HowItWorks";
import Products from "@/components/sections/Products";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import { getProducts } from "@/lib/api";

const Home = () => {
  const { data } = useQuery({ queryKey: ["catalog"], queryFn: getProducts });
  const products = data?.products || [];

  return (
    <>
      <Header />
      <CartSheet />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <AboutUs />
        <HowItWorks />
        {products.length > 0 && <Products products={products} />}
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
